import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { TranslateService } from '@ngx-translate/core';
import { DOC_TEMPLATES } from '../../services/constant';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-document-number-setting',
  templateUrl: './document-number-setting.component.html',
  styleUrls: ['./document-number-setting.component.scss']
})
export class DocumentNumberSettingComponent implements OnInit {
  documentNumberForms: FormGroup;
  yearPatternChoices = [
    {label: 'เลขปี 2 ตำแหน่งในรูป ค.ศ.', value: '%y', display: 'YY'},
    {label: 'เลขปี 4 ตำแหน่งในรูป ค.ศ.', value: '%Y', display: 'YYYY'},
    {label: 'ไม่แสดง', value: '', display: ''},
  ]

  monthPatternChoices = [
    {label: 'แสดง', value: '%m', display: 'MM'},
    {label: 'ไม่แสดง', value: '', display: ''},
  ]

  dayPatternChoices = [
    {label: 'แสดง', value: '%d', display: 'DD'},
    {label: 'ไม่แสดง', value: '', display: ''},
  ]

  documentTypeChoices = [];
  showCancel = false;
  saving = false;
  modal: NgbModalRef;
  resultMessage: string;

  @ViewChild('saveResultModal') saveResultModal: any;

  constructor(
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    this.translateService.onLangChange.subscribe(
      () => {
        this.loadDocumentTypeChoices();
      },
    );
    this.loadDocumentTypeChoices();
    this.documentNumberForms = this.formBuilder.group({
      items: this.formBuilder.array([
        this.initForm('receipt_tax_invoice'),
        this.initForm('credit_note'),
        this.initForm('debit_note'),
      ]),
    });
    this.documentNumberForms.valueChanges.subscribe(
      () => {
        this.showCancel = true;
      }
    );
    this.loadDocumentNumberSetting();
  }

  initForm(documentType: string): FormGroup {
    return this.formBuilder.group({
      documentType: [documentType],
      prefix: [''],
      yearPattern: ['%y'],
      monthPattern: ['%m'],
      dayPattern: ['%d'],
      runningDigit: [4]
    });
  }

  save() {
    this.saving = true;
    const payload = this.documentNumberForms.value.items.map(
      (item) => ({
        document_type: item.documentType,
        prefix: item.prefix,
        year_pattern: item.yearPattern,
        month_pattern: item.monthPattern,
        day_pattern: item.dayPattern,
        running_digit: item.runningDigit,
      })
    )
    this.apiService.saveDocumentNumberSetting(payload).subscribe(
      () => {
        this.saving = false;
        this.resultMessage = this.translateService.instant('SETTINGS.SAVED-SUCCESSFULLY');
        this.modal = this.modalService.open(this.saveResultModal, {centered: true, backdrop: 'static'});
      },
      (error) => {
        this.saving = false;
        this.resultMessage = this.translateService.instant('ERROR.TRY-AGAIN');
        this.modal = this.modalService.open(this.saveResultModal, {centered: true, backdrop: 'static'});
      },
    );
  }

  closeModal() {
    this.modal.close();
    this.resultMessage = undefined;
  }

  loadDocumentTypeChoices() {
    const th = this.translateService.currentLang === 'th';
    this.documentTypeChoices = DOC_TEMPLATES.map(
      (item) => (
        th ? {label: item.name, value: item.type} : {label: item.nameEN, value: item.type}
      )
    )
  }

  loadDocumentNumberSetting() {
    this.apiService.getDocumentNumberSettings().subscribe(
      (response) => {
        this.showCancel = false;
        if (!response.length) {
          return;
        }
        for (let formGroup of (this.documentNumberForms.controls.items as FormArray).controls) {
          const foundObject = response.find((item) => item.document_type === formGroup.value.documentType);
          if (foundObject) {
            formGroup.patchValue({
              prefix: foundObject.prefix,
              yearPattern: foundObject.year_pattern,
              monthPattern: foundObject.month_pattern,
              dayPattern: foundObject.day_pattern,
              runningDigit: foundObject.running_digit,
            })
          }
        }
      },
    );
  }

  get items(): FormArray {
    return this.documentNumberForms.get('items') as FormArray;
  }

  getDocumentTypeDisplay(index): string {
    const documentType = this.documentNumberForms.value.items[index].documentType;
    return this.documentTypeChoices.find(item => item.value === documentType).label;
  }

  getPatternDisplay(index): string {
    const documentNumberSetting = this.documentNumberForms.value.items[index]
    const yearPattern = this.getDisplayFromChoices(this.yearPatternChoices, documentNumberSetting.yearPattern)
    const monthPattern = this.getDisplayFromChoices(this.monthPatternChoices, documentNumberSetting.monthPattern)
    const dayPattern = this.getDisplayFromChoices(this.dayPatternChoices, documentNumberSetting.dayPattern)
    const runningDigit = '0'.repeat(documentNumberSetting.runningDigit - 1);
    const prefix = documentNumberSetting.prefix ? documentNumberSetting.prefix + '-' : '';
    return `${prefix}${yearPattern}${monthPattern}${dayPattern}-${runningDigit}1`
  }

  getDisplayFromChoices(choices, value): string {
    return choices.find(item => item.value === value).display;
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/document-number-setting/document-number-setting.component.ts